export default __webpack_public_path__ + "images/logic-stone-3.svg";